import { useMemo } from "react";

export default function FallbackEmptyValue({
  text = "",
  fallback = "-"
}: {
  text: string;
  fallback?: string;
}) {
  const result = useMemo(() => {
    if (typeof text === "string" && text.trim() !== "") {
      return text;
    } else {
      return fallback;
    }
  }, [text, fallback]);

  return <>{result}</>;
}
